// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.
// OPU = aspiration-sessions (api-reference/admin-aspiration-sessions.md).

export const opuPaths = {
    list:        ()                => 'admin/aspiration-sessions',
    detail:      (id)              => `admin/aspiration-sessions/${id}`,
    staff:       (id)              => `admin/aspiration-sessions/${id}/staff`,
    staffItem:   (id, staffId)     => `admin/aspiration-sessions/${id}/staff/${staffId}`,
    aspirations: (id)              => `admin/aspiration-sessions/${id}/aspirations`,
    aspiration:  (id, aspId)       => `admin/aspiration-sessions/${id}/aspirations/${aspId}`,
    transferSessions: (id)         => `admin/aspiration-sessions/${id}/transfer-sessions`,
};
